export default __webpack_public_path__ + "static/Poppins-Black-d8b850b920a5ef49d752d926c50c5a1a.ttf";